// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBkg6yGQr5flFJOt8Xhovrtclk6BtVdZ7c',
  authDomain: 'softestate-1db05.firebaseapp.com',
  projectId: 'softestate-1db05',
  storageBucket: 'softestate-1db05.appspot.com',
  messagingSenderId: '925816751941',
  appId: '1:925816751941:web:6506549e5f90e75799a02c',
  measurementId: 'G-5Q4M34E9EV',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)

export const db = getFirestore(app)
